export const GET_APP_CONTEXT = "GET_APP_CONTEXT";
export const GET_THEME_CONTEXT = "GET_THEME_CONTEXT";
export const GET_APP_CONTEXT_SUCCESS = "GET_APP_CONTEXT_SUCCESS";
export const GET_THEME_CONTEXT_SUCCESS = "GET_THEME_CONTEXT_SUCCESS";

export const listenForExoContext = () => ({
    type: GET_APP_CONTEXT,
});

export const listenForThemeContext = () => ({
    type: GET_THEME_CONTEXT,
});